module.exports = __webpack_public_path__ + "img/two_banner_bg4.ae8375a9.jpg";